import React, { Component } from 'react';
import Headers from './Header';
import Footer from './Footer';
import { Header, Container, Grid } from 'semantic-ui-react';
import { NotificationContainer } from 'react-notifications';
import CorporateDropdown from '../components/CorporateDropdown';
import '../../css/style.css';
import '../../semantic/dist/semantic.min.css';
import '../../../node_modules/react-notifications/dist/react-notifications.css';
import '../../css/react-table.css';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }


  render() {
    const style = {
      backgroundImage: "url(\"" + this.props.config.LAYOUT_BACKGROUND_IMAGE + "\")"
    };
    const displayStyle = this.props.location.pathname.includes('/clientAction') && new URLSearchParams(this.props.location.search).get('clientId') ? 'none' : 'block';
    return (
      <div style={style}>
        <NotificationContainer />
        <Header style={{display: displayStyle}}>
          <Headers menuitems={this.props.items.menuItems} {...this.props} />
        </Header>
        <Grid>
          <Container id="content" >
            <div style={{display: displayStyle}}><CorporateDropdown corporate={this.props.items.corporate} currentCorporate={this.props.items.currentCorporate} {...this.props} /></div>
            {this.props.children}
          </Container>
        </Grid>
        <Grid className="fluid footer-g-bkgd">
          <Grid.Row>
            <Grid.Column>
              <Footer {...this.props} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default Layout;


// WEBPACK FOOTER //
// ./src/app/layout/Layout.js